<template>
    <div class="menu-button" @click="toggleMenu">
      <i class="fa fa-bars"></i>
    </div>
  </template>
  
  <script>
  export default {
    methods: {
      toggleMenu() {
        // toggle the visibility of the menu
        this.$emit('toggle-menu')
      }
    }
  }
  </script>
  
  <style scoped>
  .menu-button {
    position: fixed;
    top: 20px;
    left: 20px;
    z-index: 999;
    cursor: pointer;
    font-size: 34px; 
  }
  </style>
  